import { render, staticRenderFns } from "./LocationCardNotice.vue?vue&type=template&id=de781846&"
import script from "./LocationCardNotice.vue?vue&type=script&lang=js&"
export * from "./LocationCardNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports